import { IComboBox, IComboBoxOption } from '@fluentui/react';
import { ComboBox, DatePicker } from '@h2oai/ui-kit';
import { useState } from 'react';

import { useTimeFilters } from './common/hooks';
import { formatDateLocal } from './common/utils';
import GaugeMetricPlot from './components/MLOps/GaugeMetricPlot/GaugeMetricPlot';
import GaugeMetricStats from './components/MLOps/GaugeMEtricTable/GaugeMetricTable';
import {
  comboBoxStyle,
  mlopsSummaryTopStyles,
  summaryDatePickerAreaStyle,
  summaryDatePickerStyle,
} from './components/MLOps/MLOps.styles';
import TimeFilters from './components/TimeFilters/TimeFilters';
import { MLOpsGaugeType, MLOpsGaugeTypeKey } from './constants';
import PageWrapper from './PageWrapper';

const metricOptions: IComboBoxOption[] = [
  {
    key: MLOpsGaugeTypeKey.deployment,
    text: MLOpsGaugeType.deployment,
  },
  {
    key: MLOpsGaugeTypeKey.user,
    text: MLOpsGaugeType.user,
  },
  {
    key: MLOpsGaugeTypeKey.project,
    text: MLOpsGaugeType.project,
  },
  {
    key: MLOpsGaugeTypeKey.dataset,
    text: MLOpsGaugeType.dataset,
  },
  {
    key: MLOpsGaugeTypeKey.experiment,
    text: MLOpsGaugeType.experiment,
  },
  {
    key: MLOpsGaugeTypeKey.registeredModel,
    text: MLOpsGaugeType.registeredModel,
  },
  {
    key: MLOpsGaugeTypeKey.registeredModelVersion,
    text: MLOpsGaugeType.registeredModelVersion,
  },
];

export default function GaugeMetricEvent() {
  const { startDate, endDate, selectedTimeFrame, handleTimeFilterChange } = useTimeFilters();
  const [selectedMetricKeys, setSelectedMetricKeys] = useState<string[]>([MLOpsGaugeTypeKey.deployment]);
  const [summaryDate, setSummaryDate] = useState<Date>(endDate);

  const handleSummaryDateChange = (date: Date | null | undefined) => {
    if (date) {
      setSummaryDate(date);
    }
  };
  const onMetricChange = (_event: React.FormEvent<IComboBox>, option?: IComboBoxOption) => {
    if (option) {
      const { key, selected } = option;

      if (selected) {
        // Add selected key and text
        setSelectedMetricKeys((prevKeys) => [...prevKeys, key as string]);
      } else {
        // Remove unselected key and text
        setSelectedMetricKeys((prevKeys) => prevKeys.filter((k) => k !== key));
      }
    }
  };
  return (
    <PageWrapper>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginBottom: '1rem',
        }}
      >
        <ComboBox
          multiSelect={true}
          placeholder="Select Gauge Type"
          options={metricOptions}
          selectedKey={selectedMetricKeys}
          onChange={onMetricChange}
          required={true}
          style={comboBoxStyle}
        />
        <TimeFilters
          startDate={startDate}
          endDate={endDate}
          selectedTimeFrame={selectedTimeFrame}
          onChange={handleTimeFilterChange}
        />
      </div>
      <div>
        <GaugeMetricPlot
          startDate={formatDateLocal(startDate)}
          endDate={formatDateLocal(endDate)}
          gaugeType={selectedMetricKeys}
        />
      </div>
      <div style={mlopsSummaryTopStyles}>
        <div>
          <h3>Total Count View</h3>
        </div>
        <div style={summaryDatePickerAreaStyle}>
          <DatePicker
            placeholder="Select date"
            style={summaryDatePickerStyle}
            value={summaryDate}
            onSelectDate={handleSummaryDateChange}
          />
        </div>
      </div>
      <div>
        <GaugeMetricStats date={formatDateLocal(summaryDate)} />
      </div>
    </PageWrapper>
  );
}
